import React, { useState } from "react";
import { SupplierNoteItem } from "../../../models/weeklyTimeline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { faCloudArrowDown, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { getTimezoneTime, downloadFile } from "./utils";

interface SupplierNoteItemProps {
  item: SupplierNoteItem;
  timezone: string;
  bottomLastMargin: string;
  verticalLineStyle: string;
}

const SupplierNoteItemComponent: React.FC<SupplierNoteItemProps> = ({
  item,
  timezone,
  bottomLastMargin,
  verticalLineStyle,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderNoteContent = (content: string) => {
    const lines = content.split('\n');
    return lines.map((line, i) => (
      <React.Fragment key={i}>
        {line}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const noteContent = item.note.notes || "No Note";
  const shortNote =
    noteContent.length > 90
      ? `${noteContent.substring(0, 87)}...`
      : noteContent;

  return (
    <div className={`mt-1 flex flex-col ${bottomLastMargin}`}>
      <div className="flex flex-row">
        <div className="flex h-[30px] w-[30px] min-w-[30px] items-center justify-center rounded-full bg-[#0a84ff]">
          <FontAwesomeIcon className="h-4 w-4 text-white" icon={faPenToSquare} />
        </div>
        <h1 className="ml-3 flex items-center justify-center text-sm text-[#212322]">
          Wrote Supplier Note
        </h1>
      </div>
      <div className="mt-1 flex flex-row items-stretch">
        <div className={`ml-[0.7rem] ${verticalLineStyle}`} />
        <div className="ml-6 h-[10%] w-full">
          <h2 className="mb-2 w-full text-xs font-light text-gray-500">
            Supplier: {item.note.supplier.name} @{" "}
            {getTimezoneTime(item.time, timezone)} {timezone}
          </h2>
          <div className="rounded-lg border-[1px] border-gray-300 py-1">
            <div>
              {item.note.attachments.map((attachment, i) => {
                const shortFileName =
                  attachment.attachment.filename.length > 35
                    ? `${attachment.attachment.filename.substring(0, 32)}...`
                    : attachment.attachment.filename;
                return (
                  <div
                    key={i}
                    className="mb-1 flex w-full flex-row items-center justify-between border-b-[1px] px-1 pb-1 cursor-pointer hover:bg-gray-50"
                    style={{ cursor: 'pointer' }}
                    onClick={() => downloadFile(
                      attachment.attachment.downloadURL,
                      attachment.attachment.filename,
                    )}
                  >
                    <FontAwesomeIcon className="h-[12px] w-[12px] text-gray-600 mr-[4px]" icon={faFile} />
                    <span className="text-xs font-light text-gray-600 underline">
                      {shortFileName}
                    </span>
                    <FontAwesomeIcon className="h-[12px] w-[12px] text-blue-600 ml-[4px]" icon={faCloudArrowDown} />
                  </div>
                );
              })}
            </div>
            <div className="max-w-[290px] break-words px-1 text-xs font-light">
              {isExpanded ? renderNoteContent(noteContent) : renderNoteContent(shortNote)}
              {noteContent.length > 90 && (
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="ml-1 text-blue-600 hover:underline"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierNoteItemComponent; 